import React, { useState } from 'react';
import api from '../config/api';
import './SyncPanel.css';

function SyncPanel() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  // Estados para inputs
  const [dealsLimit, setDealsLimit] = useState('');
  const [personsLimit, setPersonsLimit] = useState('');
  const [organizationsLimit, setOrganizationsLimit] = useState('');
  const [specificDealId, setSpecificDealId] = useState('');
  const [specificPersonId, setSpecificPersonId] = useState('');
  const [filterId, setFilterId] = useState('7682');
  const [filterLimit, setFilterLimit] = useState('');
  const [addiuvaLimit, setAddiuvaLimit] = useState('');

  const handleSync = async (type, params = {}) => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await api.post(`/api/sync/${type}`, params);
      setResult(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Error en la sincronización');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sync-panel">
      {/* Sección Deals */}
      <div className="sync-section">
        <h2>
          <span className="icon">📊</span>
          Sincronizar Deals
        </h2>

        <div className="sync-actions">
          {/* Todos los deals */}
          <div className="sync-card">
            <h3>Todos los Deals</h3>
            <p>Sincroniza todos los deals de Pipedrive</p>
            <button
              onClick={() => handleSync('deals')}
              disabled={loading}
              className="btn btn-primary"
            >
              Sincronizar Todos
            </button>
          </div>

          {/* Primeros N deals */}
          <div className="sync-card">
            <h3>Primeros N Deals</h3>
            <p>Sincroniza un número específico de deals</p>
            <input
              type="number"
              placeholder="Cantidad (ej: 100)"
              value={dealsLimit}
              onChange={(e) => setDealsLimit(e.target.value)}
              className="input"
              min="1"
            />
            <button
              onClick={() => handleSync('deals', { limit: parseInt(dealsLimit) })}
              disabled={loading || !dealsLimit}
              className="btn btn-secondary"
            >
              Sincronizar {dealsLimit || 'N'} Deals
            </button>
          </div>

          {/* Deal específico */}
          <div className="sync-card">
            <h3>Deal Específico</h3>
            <p>Sincroniza un deal por su ID</p>
            <input
              type="number"
              placeholder="ID del Deal"
              value={specificDealId}
              onChange={(e) => setSpecificDealId(e.target.value)}
              className="input"
              min="1"
            />
            <button
              onClick={() => handleSync('deal', { dealId: parseInt(specificDealId) })}
              disabled={loading || !specificDealId}
              className="btn btn-secondary"
            >
              Sincronizar Deal
            </button>
          </div>

          {/* Deals con Filtro de Pipedrive */}
          <div className="sync-card">
            <h3>Deals con Filtro Pipedrive</h3>
            <p>Usa un filtro configurado en Pipedrive (filter_id)</p>
            <input
              type="number"
              placeholder="Filter ID"
              value={filterId}
              onChange={(e) => setFilterId(e.target.value)}
              className="input"
              min="1"
            />
            <input
              type="number"
              placeholder="Límite (opcional)"
              value={filterLimit}
              onChange={(e) => setFilterLimit(e.target.value)}
              className="input"
              min="1"
            />
            <button
              onClick={() => handleSync('deals-with-filter', {
                filterId: parseInt(filterId),
                limit: filterLimit ? parseInt(filterLimit) : undefined
              })}
              disabled={loading || !filterId}
              className="btn btn-secondary"
            >
              Sincronizar con Filtro
            </button>
          </div>

          {/* Deals con Asistencia Addiuva */}
          <div className="sync-card">
            <h3>Deals con Asistencia Addiuva</h3>
            <p>Sincroniza solo deals con el campo Asistencia Addiuva</p>
            <input
              type="number"
              placeholder="Límite (opcional)"
              value={addiuvaLimit}
              onChange={(e) => setAddiuvaLimit(e.target.value)}
              className="input"
              min="1"
            />
            <button
              onClick={() => handleSync('deals-addiuva', {
                limit: addiuvaLimit ? parseInt(addiuvaLimit) : undefined
              })}
              disabled={loading}
              className="btn btn-success"
            >
              Sincronizar Addiuva
            </button>
          </div>
        </div>
      </div>

      {/* Sección Personas */}
      <div className="sync-section">
        <h2>
          <span className="icon">👥</span>
          Sincronizar Personas
        </h2>

        <div className="sync-actions">
          {/* Todas las personas */}
          <div className="sync-card">
            <h3>Todas las Personas</h3>
            <p>Sincroniza todas las personas de Pipedrive</p>
            <button
              onClick={() => handleSync('persons')}
              disabled={loading}
              className="btn btn-primary"
            >
              Sincronizar Todas
            </button>
          </div>

          {/* Primeras N personas */}
          <div className="sync-card">
            <h3>Primeras N Personas</h3>
            <p>Sincroniza un número específico de personas</p>
            <input
              type="number"
              placeholder="Cantidad (ej: 100)"
              value={personsLimit}
              onChange={(e) => setPersonsLimit(e.target.value)}
              className="input"
              min="1"
            />
            <button
              onClick={() => handleSync('persons', { limit: parseInt(personsLimit) })}
              disabled={loading || !personsLimit}
              className="btn btn-secondary"
            >
              Sincronizar {personsLimit || 'N'} Personas
            </button>
          </div>

          {/* Persona específica */}
          <div className="sync-card">
            <h3>Persona Específica</h3>
            <p>Sincroniza una persona por su ID</p>
            <input
              type="number"
              placeholder="ID de la Persona"
              value={specificPersonId}
              onChange={(e) => setSpecificPersonId(e.target.value)}
              className="input"
              min="1"
            />
            <button
              onClick={() => handleSync('person', { personId: parseInt(specificPersonId) })}
              disabled={loading || !specificPersonId}
              className="btn btn-secondary"
            >
              Sincronizar Persona
            </button>
          </div>
        </div>
      </div>

      {/* Sección Organizaciones */}
      <div className="sync-section">
        <h2>
          <span className="icon">🏢</span>
          Sincronizar Organizaciones
        </h2>

        <div className="sync-actions">
          {/* Todas las organizaciones */}
          <div className="sync-card">
            <h3>Todas las Organizaciones</h3>
            <p>Sincroniza todas las organizaciones de Pipedrive</p>
            <button
              onClick={() => handleSync('organizations')}
              disabled={loading}
              className="btn btn-primary"
            >
              Sincronizar Todas
            </button>
          </div>

          {/* Primeras N organizaciones */}
          <div className="sync-card">
            <h3>Primeras N Organizaciones</h3>
            <p>Sincroniza un número específico de organizaciones</p>
            <input
              type="number"
              placeholder="Cantidad (ej: 100)"
              value={organizationsLimit}
              onChange={(e) => setOrganizationsLimit(e.target.value)}
              className="input"
              min="1"
            />
            <button
              onClick={() => handleSync('organizations', { limit: parseInt(organizationsLimit) })}
              disabled={loading || !organizationsLimit}
              className="btn btn-secondary"
            >
              Sincronizar {organizationsLimit || 'N'} Organizaciones
            </button>
          </div>
        </div>
      </div>

      {/* Sincronización de campos */}
      <div className="sync-section">
        <h2>
          <span className="icon">🏷️</span>
          Sincronizar Campos de Deal
        </h2>
        <div className="sync-actions">
          <div className="sync-card">
            <h3>Definiciones de Campos</h3>
            <p>Sincroniza los campos personalizados desde Pipedrive para poder mapearlos</p>
            <button
              onClick={() => handleSync('deal-fields')}
              disabled={loading}
              className="btn btn-info"
            >
              Sincronizar Campos
            </button>
          </div>
        </div>
      </div>

      {/* Sincronización completa */}
      <div className="sync-section sync-all">
        <h2>
          <span className="icon">🔄</span>
          Sincronización Completa
        </h2>
        <p>Sincroniza todos los deals y todas las personas</p>
        <button
          onClick={() => handleSync('all')}
          disabled={loading}
          className="btn btn-large btn-gradient"
        >
          Sincronizar Todo
        </button>
      </div>

      {/* Loading */}
      {loading && (
        <div className="status-box loading">
          <div className="spinner"></div>
          <p>Sincronizando...</p>
        </div>
      )}

      {/* Result */}
      {result && !loading && (
        <div className="status-box success">
          <h3>✓ Sincronización Completada</h3>
          <div className="result-details">
            {result.deals && (
              <div className="result-item">
                <strong>Deals:</strong>
                <ul>
                  <li>Total: {result.deals.total}</li>
                  <li>Creados: {result.deals.created}</li>
                  <li>Actualizados: {result.deals.updated}</li>
                  {result.deals.errors > 0 && (
                    <li className="error-text">Errores: {result.deals.errors}</li>
                  )}
                </ul>
              </div>
            )}
            {result.persons && (
              <div className="result-item">
                <strong>Personas:</strong>
                <ul>
                  <li>Total: {result.persons.total}</li>
                  <li>Creadas: {result.persons.created}</li>
                  <li>Actualizadas: {result.persons.updated}</li>
                  {result.persons.errors > 0 && (
                    <li className="error-text">Errores: {result.persons.errors}</li>
                  )}
                </ul>
              </div>
            )}
            {result.organizations && (
              <div className="result-item">
                <strong>Organizaciones:</strong>
                <ul>
                  <li>Total: {result.organizations.total}</li>
                  <li>Creadas: {result.organizations.created}</li>
                  <li>Actualizadas: {result.organizations.updated}</li>
                  {result.organizations.errors > 0 && (
                    <li className="error-text">Errores: {result.organizations.errors}</li>
                  )}
                </ul>
              </div>
            )}
            {result.deal && (
              <div className="result-item">
                <strong>Deal sincronizado:</strong>
                <p>{result.deal.title} (ID: {result.deal.pipedriveId})</p>
              </div>
            )}
            {result.person && (
              <div className="result-item">
                <strong>Persona sincronizada:</strong>
                <p>{result.person.name} (ID: {result.person.pipedriveId})</p>
              </div>
            )}
            {result.fields && (
              <div className="result-item">
                <strong>Campos sincronizados:</strong>
                <ul>
                  <li>Total: {result.fields.total}</li>
                  <li>Sincronizados: {result.fields.synced}</li>
                  {result.fields.errors > 0 && (
                    <li className="error-text">Errores: {result.fields.errors}</li>
                  )}
                </ul>
              </div>
            )}
            {result.message && (
              <p className="result-message">{result.message}</p>
            )}
            {result.duration && (
              <p className="result-duration">Duración: {result.duration}s</p>
            )}
          </div>
        </div>
      )}

      {/* Error */}
      {error && !loading && (
        <div className="status-box error">
          <h3>✗ Error</h3>
          <p>{error}</p>
        </div>
      )}
    </div>
  );
}

export default SyncPanel;
